import React, { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { DifmUpsellDialog } from '@yola/webapp-plugins';
import { selectors, verifiers } from '@yola/subscription-manager-js';
import dialogs from 'src/js/modules/dialogs';
import user from 'src/js/modules/user';
import segment from 'src/js/modules/analytics/segment';
import useFeatureFlags from 'src/js/modules/feature-flags/hooks/use-feature-flags';

const {
  track,
  constants: { events },
} = segment;

const DifmUpsellDialogContainer = () => {
  const dispatch = useDispatch();
  const partnerData = useSelector(user.selectors.getPartnerData, shallowEqual);
  const { currency } = useSelector(user.selectors.getUserPreferences, shallowEqual);
  const activeHostingSubscription = useSelector(selectors.getActiveHostingSubscription);
  const hasPaidHostingSubscription =
    activeHostingSubscription?.type &&
    verifiers.hasPaidHostingPackageType([activeHostingSubscription.type]);

  const [featureFlags] = useFeatureFlags(['gold_reinforcement']);
  const { gold_reinforcement: isGoldReinforcementFeatureFlagEnabled } = featureFlags;

  useEffect(() => {
    track(events.DIFM_UPSELL_DISPLAYED, {
      businessCategory: null,
      siteId: null,
      templateBuildSlug: null,
    });
  }, []);

  const onClose = useCallback(() => {
    dispatch(dialogs.actions.hide());

    track(events.DIFM_UPSELL_CLOSE_CLICKED, {
      businessCategory: null,
      siteId: null,
      templateBuildSlug: null,
    });
  }, [dispatch]);

  const onSubmit = useCallback(() => {
    track(events.DIFM_UPSELL_UPGRADE_CLICKED, {
      businessCategory: null,
      siteId: null,
      templateBuildSlug: null,
    });

    dispatch(dialogs.actions.show(dialogs.dialogTypes.DIFM_ORDER_FORM_DIALOG));
  }, [dispatch]);

  return (
    <DifmUpsellDialog
      partnerId={partnerData.id}
      term={activeHostingSubscription?.term}
      currency={currency}
      shouldReinforcePlanNames={isGoldReinforcementFeatureFlagEnabled}
      isUpgradeFlow={hasPaidHostingSubscription}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export default DifmUpsellDialogContainer;
